import { render, staticRenderFns } from "./datajob__alilog.vue?vue&type=template&id=1422b53d"
import script from "./datajob__alilog.vue?vue&type=script&lang=js"
export * from "./datajob__alilog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports